import { ImageDimensions } from '../shared-types';

const defaultImageInitialDimensions: ImageDimensions = {
  width: 100,
  height: 100
};

export default defaultImageInitialDimensions;
